import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useCurrentUserStore } from "@src/state/currentUserState";

export default function RequiresActiveClinicContainer(): React.JSX.Element | null {
  const { currentUser, loading } = useCurrentUserStore();

  if (loading || !currentUser) return null;

  if (currentUser.clinicUsers.length === 0) {
    return <Navigate to="/clinic-setup" replace />;
  }

  const defaultClinicUser =
    currentUser.clinicUsers.find((cu) => cu.isDefault) ??
    currentUser.clinicUsers[0];

  if (defaultClinicUser.status !== "active") {
    return <Navigate to="/clinic-pending" replace />;
  }

  return <Outlet />;
}
